import { Moment } from 'moment';
import { ProfileType } from '../../../common/enums/ProfileType';

export class OrganizationProfile {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly type: ProfileType,
    private readonly reportCount: number,
    private readonly projectCount: number,
    private readonly preset: boolean,
    private readonly lastUsed: Moment | null
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getReportCount() {
    return this.reportCount;
  }

  getProjectCount() {
    return this.projectCount;
  }

  isPreset() {
    return this.preset;
  }

  getLastUsed() {
    return this.lastUsed;
  }
}
